module.exports = __webpack_public_path__ + "img/noble3.aaf4bb22.png";